import React from 'react';
import styled from 'styled-components';
import { useRecoilValue } from 'recoil';
import MusicButton from '@template/MusicPlayer/MusicBtn';
import NotificationBtn from '@template/Notifications/NotificationBtn';
import ChatBtn from '@pages/Chat/ChatBtn';
import LoginUserSec from './LoginUserSec';
import { masterSet } from '@masterSetting/masterSet/masterSetting';
import { iconDirectionState, layoutDirState } from '@atom/setting/homepageSet';
import { LAYOUT_DIR } from '@typings/setting/layoutDir';

const ButtonGroup = styled.div<{ direction: 'row' | 'column' }>`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin: 12px 0;
`;

type DropdownDirType =
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom'
  | 'top'
  | 'bottom';

type Props = {
  showLogin?: boolean;
  color?: string;
  dropdownDir?: DropdownDirType;
  loginSize?: string;
  style?: React.CSSProperties;
};

function NavIconButtonGroup({
  showLogin = true,
  color = 'var(--menuTextColor)',
  dropdownDir,
  loginSize = '40px',
  style,
}: Props) {
  const iconDirection = useRecoilValue(iconDirectionState);
  const layoutDir = useRecoilValue(layoutDirState);

  // 기본 드롭다운 방향 결정
  const defaultDropdownDir: DropdownDirType =
    layoutDir === LAYOUT_DIR.LEFT ? 'leftBottom' : 'rightBottom';
  const finalDropdownDir = dropdownDir || defaultDropdownDir;

  return (
    <ButtonGroup direction={iconDirection} style={style}>
      {showLogin && (
        <LoginUserSec dropdownDir={finalDropdownDir} size={loginSize} />
      )}
      <NotificationBtn dropdownDir={finalDropdownDir} color={color} />
      {masterSet.chat && <ChatBtn color={color} />}
      <MusicButton color={color} />
    </ButtonGroup>
  );
}

export default React.memo(NavIconButtonGroup);

